import React from 'react';
import { NavLink } from "react-router-dom";
import { AuthContext } from '../context/AuthContext';
import src from '../Styles/ECLOGOSVG.svg'
import './Sidebar.css'

const navItems = [
    {
        label: 'Договоры',
        path: 'dc',
        allowedRoles: ['user']
    },
    {
        label: 'Рассрочка',
        path: 'agreement',
        allowedRoles: ['user']
    },
    // {
    //     label: 'История платежей',
    //     path: 'di', 
    //     allowedRoles: ['user']
    // },
    {
        label: 'Оплатить',
        path: 'dp',
        allowedRoles: ['user']
    },
    {
        label: 'Обращения',
        path: 'docs',
        allowedRoles: ['user']
    },
    {
        label: 'Судебные документы',
        path: 'court-docs',
        allowedRoles: ['user'],
        requiresCourtDocs: true
    },
    {
        label: 'Редакция',
        path: 'admin-articles',
        allowedRoles: ['admin']
    },
    {
        label: 'Все посты',
        path: 'all-articles',
        allowedRoles: ['admin']
    },
    {
        label: 'Обращения с сайта',
        path: 'admin-page',
        allowedRoles: ['admin']
    },
    {
        label: 'Отработанные заявки',
        path: 'admin-page-resolved',
        allowedRoles: ['admin']
    },
    {
        label: 'Обращения из ЛК',
        path: 'upload-notes',
        allowedRoles: ['admin']
    },
    {
        label: 'Вакансии',
        path: 'upload-vacancy',
        allowedRoles: ['admin']
    },
    {
        label: 'Кандидаты',
        path: 'get-candidates',
        allowedRoles: ['admin']
    },
    {
        label: 'Вопросы клиентов',
        path: 'all-questions',
        allowedRoles: ['admin']
    },
]

navItems.push({
    label: 'Должники',
    path: 'admin-debtors',
    allowedRoles: ['admin']
})

const NavItem = ({ navItem, onClick }) => {
    return (
        <NavLink
            to={navItem.path}
            onClick={onClick}
            className={({ isActive }) => `sbNavLink${isActive ? ' sbNavLink--active' : ''}`}
        >
            <div className='sbLink'>
                <span>{navItem.label}</span>
            </div>
        </NavLink>
    )
}

const NavItemContainer = ({ children }) => (
    <div>{children}</div>
)

const Sidebar = () => {
    const auth = React.useContext(AuthContext)
    const { role } = auth.authState.userInfo.role
        ? auth.authState.userInfo
        : auth.authState.userInfo.dataValues

    const [menuOpen, setMenuOpen] = React.useState(false);
    const sidebarRef = React.useRef(null);

    const isVisible = (navItem) => {
        if (!navItem.allowedRoles.includes(role)) return false;
        if (navItem.requiresCourtDocs && !auth.hasCourtDocs()) return false;
        return true;
    }

    React.useEffect(() => {
        const update = () => {
            if (sidebarRef.current) {
                document.documentElement.style.setProperty(
                    '--header-h',
                    sidebarRef.current.offsetHeight + 'px'
                );
            }
        };
        update();
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, [menuOpen]); // пересчитываем когда меню открывается/закрывается

    return (
        <section className='SidebarSection' ref={sidebarRef}>
            <div className='SidebarLogo'>
                <a href='/'>
                    <img src={src} alt='dashboard-logo' />
                </a>
            </div>

            {/* Бургер-кнопка — только на мобилке через CSS */}
            <button
                className='BurgerBtn'
                onClick={() => setMenuOpen(prev => !prev)}
                aria-label='Меню'
            >
                <span className={`BurgerLine ${menuOpen ? 'open' : ''}`} />
                <span className={`BurgerLine ${menuOpen ? 'open' : ''}`} />
                <span className={`BurgerLine ${menuOpen ? 'open' : ''}`} />
            </button>

            <div className={`SidebarItems ${menuOpen ? 'mobile-open' : ''}`}>
                {navItems.map((navItem, i) => (
                    <NavItemContainer key={i}>
                        {isVisible(navItem) && (
                            <NavItem navItem={navItem} onClick={() => setMenuOpen(false)} />
                        )}
                    </NavItemContainer>
                ))}
            </div>
        </section>
    )
}

export default Sidebar
